import React from "react";
import mekoLogo from "../assets/MEKO_LOGO.svg";

const ImpressumDe = () => {
  return (
    <div className="container" style={{ paddingTop: 50, paddingBottom: 50 }}>
      <div style={{ marginBottom: 30 }}>
        <a href="/">
          <img src={mekoLogo} alt="MEKO Logo" className="hero-logo-badge" />
        </a>
      </div>
      <h1>Impressum</h1>
      <h3 className="headline-3">Angaben gemäß § 5 E-Commerce-Gesetz (ECG)</h3>

      <p>
        <strong>MEKO Metallkomponenten Ges.m.b.H.</strong>
        <br />
        Triester Straße 447a
        <br />
        8055 Graz
        <br />
        Österreich
      </p>

      <p>
        <strong>Tel.:</strong>{" "}
        <a href="tel:+43316296959">+43 (0) 316 296 959</a>
        <br />
        <strong>Fax:</strong>{" "}
        <a href="tel:+4331629695910">+43 (0) 316 296 959 10</a>
        <br />
        <strong>E-Mail:</strong> <a href="mailto:info@meko.at">info@meko.at</a>
      </p>

      <p>
        <strong>Geschäftsführung:</strong> Roland Gleich
        <br />
        <strong>Firmenbuchnummer:</strong> FN 115915p
        <br />
        <strong>Firmenbuchgericht:</strong> Landesgericht für ZRS Graz
        <br />
        <strong>UID-Nummer:</strong> ATU62345714
        <br />
      </p>

      <p>
        <strong>Mitglied bei:</strong> WKO Steiermark
        <br />
        <strong>Berufsrecht:</strong> Gewerbeordnung:{" "}
        <a
          href="https://www.ris.bka.gv.at"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.ris.bka.gv.at
        </a>
        <br />
        <strong>Aufsichtsbehörde/Gewerbebehörde:</strong> Magistrat der Stadt
        Graz
      </p>

      <p>
        <strong>Unternehmensgegenstand:</strong> Handel mit Metallen und
        Metallerzeugnissen
      </p>

      <br />

      <h4>Urheber- und Kennzeichenrecht</h4>
      <p>
        Der Betreiber dieser Seiten ist bestrebt, in allen Publikationen die
        Urheberrechte der verwendeten Bilder, Grafiken, Tondokumente,
        Videosequenzen und Texte zu beachten, von ihm selbst erstellte Bilder,
        Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf
        lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte
        zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf.
        durch Dritte geschützten Marken- und Warenzeichen unterliegen
        uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts
        und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein
        aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass
        Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright
        für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein
        beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher
        Grafiken, Tondokumente, Videosequenzen und Texte in anderen
        elektronischen oder gedruckten Publikationen ist ohne ausdrückliche
        Zustimmung des Autors nicht gestattet.
      </p>
    </div>
  );
};

export default ImpressumDe;
